import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useMenuCardStyles = makeStyles(
  (theme: Theme) => ({
    menuContainer: {
      '& .MuiPaper-root, & .v5-MuiPaper-root': {
        borderRadius: '8px',
        boxShadow: 'none',
        background:
          theme.palette?.mode === 'dark'
            ? '#383838'
            : 'var(--xlrt-color-ui-gray95)',
        minWidth: '8.75rem',

        '& .MuiList-root, & .v5-MuiList-root': {
          padding: '0',
        },
        '& .MuiMenuItem-root, & .v5-MuiMenuItem-root': {
          display: 'flex',
          padding: '0.75rem 0.6rem',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          '&:hover': {
            backgroundColor:
              theme.palette?.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(0, 0, 0, 0.06)',
          },
        },
      },
    },
    itemText: {
      fontSize: '1rem',
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
      lineHeight: 'normal',
      fontWeight: 400,
    },
    renameIcon: {
      fontSize: '1rem',
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
    },
    deleteIcon: {
      fontSize: '1rem',
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
    },
    deleteText: {
      fontSize: '1rem',
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
      lineHeight: 'normal',
      fontWeight: 400,
    },
  }),
  { name: 'ConversationMenuCard' },
);
